import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Widget } from '@typeform/embed-react';
import { v4 as uuidv4 } from 'uuid';
import '../styles.css'; // Import your CSS for consistent styling

const Test: React.FC = () => {
  const navigate = useNavigate();
  const [answers, setAnswers] = useState({});

  useEffect(() => {
    const widget = document.querySelector(
      '.typeform-widget iframe'
    ) as HTMLIFrameElement;

    const handleQuestionAnswered = (event: any) => {
      const { response_id, field, answer } = event;

      setAnswers(prevAnswers => ({
        ...prevAnswers,
        [field.id]: answer,
      }));
    };

    const hiddenFields = {
      form_id: uuidv4(),
    };

    localStorage.setItem('form_id', hiddenFields.form_id);

    widget?.addEventListener('questionAnswered', handleQuestionAnswered);

    const urlParams = new URLSearchParams(hiddenFields).toString();
    const typeFormUrl = `https://form.typeform.com/to/Etjq05IC#${urlParams}`;

    if (widget) {
      widget.src = typeFormUrl;
    }

    return () => {
      widget?.removeEventListener('questionAnswered', handleQuestionAnswered);
    };
  }, [answers]);

  const handleSubmit = () => {
    navigate(`/signup`, { state: { formPage: true } }); // Navigate to the desired page after submission
  };

  useEffect(() => {
    const handleFormSubmit = (event: any) => {
      if (event.data.type === 'form-submit') {
        handleSubmit();
      }
    };

    window.addEventListener('message', handleFormSubmit);

    return () => {
      window.removeEventListener('message', handleFormSubmit);
    };
  }, [answers]);

  return (
    <div className='typeform-wrapper'>
      <Widget
        id='Etjq05IC' // Replace with your Typeform ID
        style={{ width: '100%', height: '100%' }}
        className='typeform-widget'
        onSubmit={() => console.log('Submitted...')}
        onReady={event => console.log(event)}
      />
    </div>
  );
};

export default Test;
